<template>
  <v-dialog
    v-model="show"
    width="70%"
    overlay-color="darktext"
    overlay-opacity="0.6"
    content-class="content-create-template-dialog"
    :persistent="true"
    data-testid="dialog"
    scrollable
    ref="dialog"
  >
    <v-card elevation="0" class="pa-5" v-if="role == 'space_admin' && !loading">
      <v-card-title class="white pa-0 justify-center d-block">
        <v-row no-gutters>

          <v-col cols="12" md="2">
            <v-btn
              ref="back"
              text
              data-testid="back-button"
              class="rounded-xxl text-none pa-4"
              :ripple="false"
              style="z-index: 1"
              color="greytext"
              @click="redirectToMySpaces"
            >
              <v-icon class="ml-n1">mdi-chevron-left</v-icon
              >{{ $t("spacePageTitle") }}
            </v-btn>
          </v-col>
          <v-col cols="12" md="8" v-if="!mobile()">
            <p class="text-h4 font-weight-bold text-center no-break mt-8">
              {{ $t("lockPlatformPaymentFailedTitle") }}
            </p>
          </v-col>
          <v-col cols="12" md="8" v-else>
            <p
              class="
                text-body-1
                font-weight-bold
                text-center
                no-break
                mt-8
                mb-n2
              "
            >
              {{ $t("lockPlatformPaymentFailedTitle") }}
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="8" offset-md="2" v-if="!mobile()">
            <p class="text-body-1 text-center no-break greytext--text">
              {{ $t("lockPlatformPaymentFailedText") }}
            </p>
          </v-col>
          <v-col cols="12" md="8" offset-md="2" v-else>
            <p class="text-body-2 text-center no-break greytext--text">
              {{ $t("lockPlatformPaymentFailedText") }}
            </p>
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text style="height: 70vh" ref="content" class="pa-0">
        <v-row no-gutters class="fill-height" align="center" justify="center">
          <v-col
            data-testid="get-portal"
            cols="12"
            class="d-flex flex-column justify-center align-center mx-auto"
          >
            <v-icon size="220" color="greytextlight"> mdi-lock-outline </v-icon>
            <v-btn
              color="accent"
              class="rounded-xxl text-none px-4 mt-5 submit mt-10"
              @click="getStripePortal()"
            >
              {{ $t("paymentFailedMethods") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card elevation="0" class="pa-5" v-if="role != 'space_admin' && !loading">
      <v-card-title class="white pa-0 justify-center d-block">
        <v-row no-gutters >
          <v-col cols="12" md="2">
            <v-btn
              ref="back"
              text
              data-testid="back-button"
              class="rounded-xxl text-none pa-4"
              :ripple="false"
              style="z-index: 1"
              color="greytext"
              @click="redirectToMySpaces"
            >
              <v-icon class="ml-n1">mdi-chevron-left</v-icon
              >{{ $t("spacePageTitle") }}
            </v-btn>
          </v-col>
          <v-col cols="12" md="8">
            <p class="text-h4 font-weight-bold text-center no-break mt-8">
              {{ $t("lockPlatformPaymentFailedTitle2") }}
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="8" offset-md="2">
            <p class="text-h6 text-center no-break">
              {{ $t("lockPlatformPaymentFailedText2") }}
            </p>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text style="height: 70vh" ref="content" class="pa-0">
        <v-row no-gutters class="fill-height" align="center" justify="center">
          <v-col
            cols="12"
            md="8"
            class="d-flex flex-column justify-center align-center"
          >
            <v-icon size="220"> mdi-lock-outline </v-icon>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
//import i18n from "./../plugins/i18n";
import { repeatedMethodsMixin } from "../mixins/repeatedMethodsMixin";
import { getStripePortal } from "../api/spaceApi";
//import { eventBus } from "../eventbus";

export default {
  components: {},
  props: {
    //visible: Boolean
  },
  mixins: [repeatedMethodsMixin],
  data() {
    return {
      alertMsg: "",
      alertType: "",
      alertValue: false,
      spaceId: window.$cookies.get("space_id"),
      space: window.location.host.split(".")[0],
      loading: false,
      role: localStorage.space ? JSON.parse(localStorage.space).role : null,
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
    visible() {
      return this.$store.state.lockPaymentFailed;
    },
  },
  watch: {
    visible() {
      this.loading = true;
      this.role = JSON.parse(localStorage.space).role;
      this.loading = false;
    },
  },
  methods: {
    closeDialog() {
      this.$emit("close");
    },
    async getStripePortal() {
      try {
        const response = await getStripePortal(this.spaceId);
        if (response.status) {
          if (response.status == 200) {
            window.location.href = response.data.meta.stripe_portal_url;
          }
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status == 403) {
            this.$router.push({ name: "PageAccessDenied" });
          } else {
            this.$emit("proceedError");
          }
        }
      }
    },

    redirectToMySpaces() {
      window.location.href =
        process.env.VUE_APP_PROTOCOL +
        "://id." +
        process.env.VUE_APP_DOMAIN +
        "/spaces";
    },
  },
};
</script>
